<template>
    <div class="homepage">

        <pinned-message />

        <div class="hero-with-slider">
            <slick ref="slick-reviews" :options="slick_options" v-if="hero_slides.length">
                <div v-for="(slide,index) in hero_slides" v-bind:key="index" class="hero-with-slider--slide" :style="'background-image:url('+slide.wallpaper+')'">
                    <div class="slickCredits" v-if="slide.credits && slide.credits !== ''" v-html="slide.credits"></div>
                    <div class="hero-with-slider--slide-content">
                        <div class="hero-with-slider--slide-wrapper">
                        <h3 class="hero-with-slider--slide-title" v-html="slide.title"></h3>
                        <p class="hero-with-slider--slide-text" v-html="slide.text"></p>
                        </div>
                    </div>
                </div>
            </slick>
        </div>


        <div class="content" v-if="is_authenticated()">
            <b-container fluid>
                <div class="tabs panel">
                    <b-container class="tabs--heading">
                        <div class="tabs--heading--categories">
                            <div v-for="category in home_categories" v-bind:key="'tab-category-' + category" @click="toggle_category(category)" >
                                <div class="tabs--heading--item" v-if="filter_stories(category).length | filter_products(category).length">
                                    <div :class="(show_category == category ? 'active' : '')" v-html="categories[category].title"></div>
                                </div>
                            </div>
                        </div>
                        <div class="request-button">
                            <div class="request-button--content">
                                <div class="request-button--label">
                                    Scopri il viaggio perfetto per te
                                </div>
                                <button-with-icon
                                    variant="success"
                                    text="Inizia qui"
                                    :clicked="() => {
                                        this.$bvModal.show('request-modal')
                                    }"
                                />
                                <b-modal id="request-modal" title="Organizza il tuo viaggio" size="xl" hide-footer>
                                    <request-send-access-link custom_event_action="homepage"/>
                                </b-modal>
                            </div>
                        </div>
                    </b-container>
                    <hr class="panel--separator fullwidth" />
                    <b-container class="tabs--content">
                        <div v-for="category in home_categories" v-bind:key="'category-' + category">
                            <div v-if="show_category == category">
                                <div>
                                    <b-spinner v-if="loading_posts" variant="primary" class="mb-4" />
                                    <stories-list
                                        v-else-if="filter_stories(category).length"
                                        :stories="filter_stories(category)"
                                        :category_code="categories[category].categoryCode"
                                    />
                                </div>
                                <div>
                                    <b-spinner v-if="loading_results" variant="primary" />
                                    <products-list
                                        v-else-if="filter_products(category).length"
                                        :results="filter_products(category)"
                                        :category_code="categories[category].categoryCode"
                                    />
                                </div>
                            </div>
                        </div>
                    </b-container>
                </div>
            </b-container>
        </div>
        <div v-else>
            <b-container class="mt-3">
              <h2><strong>Agenzia Viaggi by Vivamod</strong> è un portale online di prenotazione viaggi<br> per il welfare aziendale, creato in collaborazione con <strong>Edenred.</strong></h2>

              <div class="services">
                <h3 class="services__title">La nostra offerta:</h3>

                <b-row class="mt-5 mb-4">
                  <div class="services__element col-md-6">
                    <div class="services__icon" v-html="hand_user"></div>
                    <p class="services__text">La stessa attenzione alle tue esigenze di un'agenzia viaggi tradizionale</p>
                  </div>
                  <div class="services__element col-md-6">
                    <div class="services__icon" v-html="pc_stars_bed"></div>
                    <p class="services__text">La semplicità del booking online</p>
                  </div>
                  <div class="services__element col-md-6">
                    <div class="services__icon" v-html="pc_pay_online"></div>
                    <p class="services__text">Il pagamento online con il tuo credito welfare</p>
                  </div>
                  <div class="services__element col-md-6">
                    <div class="services__icon" v-html="customer_care"></div>
                    <p class="services__text">Il tuo agente di viaggio di fiducia a portata di click</p>
                  </div>
                </b-row>
              </div>

              <h2>Accedi al nostro sito tramite <strong>portale welfare</strong>, potrai consultare i nostri <strong>consigli</strong> per il tuo prossimo viaggio e richiedere il <strong>form</strong> da compilare per essere ricontattato da un nostro operatore.</h2>

              <div class="vp my-5">
                <p class="vp__text">Prenotazioni in<br> due click!</p>
                <img class="vp__image" src="assets/pc_adv.jpg">
              </div>

              <h2><strong>Agenzia Viaggi by Vivamod</strong> è un servizio pensato appositamente per prenotazioni semplici e dedicate agli <strong>utenti welfare</strong>. I nostri <strong>esperti di viaggio</strong> sapranno consigliarti e guidarti nella scelta del <strong>pacchetto migliore</strong> per le tue esigenze.
                <br><br>
                <strong>Contattaci per maggiori informazioni!</strong>
                <br>
                Il nostro <strong>customer service</strong> è pronto ad assisterti durante tutto il percorso per individuare la soluzione migliore per te
              </h2>

              <div class="fake_btn">
                <p>Cerca il nostro servizio nel tuo portale welfare aziendale!</p>
              </div>

              <b-row class="prefooter">
                <div class="prefooter__element col-md-6 col-lg-3">
                  <div class="prefooter__icon" v-html="chat"></div>
                  <p class="prefooter__text">
                    <strong>Online Chat</strong>
                    <small>lun-ven 9.00 - 19:00</small>
                  </p>
                </div>
                <div class="prefooter__element col-md-6 col-lg-3">
                  <div class="prefooter__icon" v-html="whatsapp"></div>
                  <p class="prefooter__text">
                    <strong>WhatsApp {{ site.mobileNumber }}</strong>
                    <small>lun-ven 9.00 - 19:00</small>
                  </p>
                </div>
                <div class="prefooter__element col-md-6 col-lg-3">
                  <div class="prefooter__icon" v-html="mail"></div>
                  <p class="prefooter__text">
                    <strong>{{ site.emailSupport }}</strong>
                    <small>lun-dom 9.00 - 19:00</small>
                  </p>
                </div>
                <div class="prefooter__element col-md-6 col-lg-3">
                  <div class="prefooter__icon" v-html="telephone"></div>
                  <p class="prefooter__text">
                    <strong>{{ site.phoneNumber }}</strong>
                    <small>lun-ven 9.00 - 19:00</small>
                  </p>
                </div>
              </b-row>

            </b-container>
        </div>
    </div>
</template>

<script>
    //import _ from 'lodash'
    import Vue from 'vue'
    import Slick from 'vue-slick'
    import Router from '@/router'
    import { search, posts } from '@/api'
    import { is_authenticated } from '@/utilities'
    import ProductsList from '@/components/blocks/products-list'
    import StoriesList from '@/components/blocks/stories-list'
    import PinnedMessage from '@/components/blocks/pinned-message'
    import Bwi from '@/components/atoms/button-with-icon'
    import RequestSendAccessLink from '@/components/blocks/request-send-access-link'
    import {hand_user, pc_stars_bed, pc_pay_online, customer_care, chat, whatsapp, mail, telephone } from '@/components/svg/common'

    export default {
        name: 'homepage',
        components: {
            'slick': Slick,
            'products-list': ProductsList,
            'stories-list': StoriesList,
            'pinned-message': PinnedMessage,
            'button-with-icon': Bwi,
            'request-send-access-link': RequestSendAccessLink,
        },
        data() {
            return {
                site: Vue.prototype.$config.site,
                loading_posts: true,
                loading_results: true,
                results: [],
                stories: [],
                home_categories: (Vue.prototype.$config.guiSettings)? Vue.prototype.$config.guiSettings.homeCategories : [],
                categories: Vue.prototype.$config.livetravelCategories,
                show_category: '',
                hero_slides: [],
                slick_options: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots:true,
                    fade:true,
                    arrows:false,
                    autoplay:true,
                    speed: 2500,
                    autoplaySpeed: (Vue.prototype.$config.guiSettings)? Vue.prototype.$config.guiSettings.autoplaySpeedHome : 3000,
                },
            }
        },
        computed: {
        },
        created()
        {
            this.router = Router
            this.is_authenticated = is_authenticated
            this.hand_user = hand_user
            this.pc_stars_bed = pc_stars_bed
            this.pc_pay_online = pc_pay_online
            this.customer_care = customer_care
            this.chat = chat
            this.whatsapp = whatsapp
            this.mail = mail
            this.telephone = telephone
        },
        mounted() {

            if(this.home_categories.length) this.show_category = this.home_categories[0]
            if (Vue.prototype.$config.sliderHome && Vue.prototype.$config.sliderHome.private.length)
            {
                if(Vue.prototype.$config.integration && Vue.prototype.$config.sliderHome.private.length){
                    this.hero_slides = Vue.prototype.$config.sliderHome.private
                }
                else if(Vue.prototype.$config.sliderHome.public)
                {
                    this.hero_slides = Vue.prototype.$config.sliderHome.public
                }

            }

            if(is_authenticated()){

              search({})
                  .then( response => {
                    this.loading_results = false
                    this.results = response.results
                    //this.log(response)
                  })

              posts({
                //category: Vue.prototype.$config.posts.stories,
                tag: Object.values(this.categories).map(c => c.storiesTagId).join(","),
                asArray: true,
              })
                  .then( response => {
                    this.stories = response.posts
                    this.loading_posts = false
                    //this.log(response)
                  })

            }


        },
        methods:{
            toggle_category(category)
            {
                this.show_category = category
            },
            filter_stories(category)
            {
                let _this = this
                return this.stories.filter(function(r){ return r.firstTagId == _this.categories[category].storiesTagId })
            },
            filter_products(category)
            {
                return this.results.filter(function(r){ return r.categoryCode == category })
            },
        },
    }
</script>

<style lang="scss">
.homepage
{
  $request-button-width:260px;
  .tabs
  {
      &--heading
      {
          display:flex;
          flex-wrap: wrap;
          align-items:center;
          &--categories
          {
              display:flex;
              flex-wrap: wrap;
              align-items:center;
              @include media-breakpoint-up(md)
              {
                  //flex-wrap: unset;
                  max-width: calc(100% - #{$request-button-width} - 40px);
                  .tabs--heading--item
                  {
                      white-space: nowrap;
                  }
                  overflow: scroll;
                  -ms-overflow-style: none;
                  scrollbar-width: none;
                  &::-webkit-scrollbar
                  {
                     display: none;
                  }
              }
              @include media-breakpoint-up(lg)
              {
                  &>div:not(:last-child)
                  {
                      border-right:1px solid $light;
                  }
                  &>div:first-child
                  {
                      .tabs--heading--item
                      {
                          padding-left:0;
                      }
                  }
              }
          }
          .request-button
          {
              flex:1;
              display:flex;
              align-items: flex-end;
              justify-content: flex-end;
              &--label
              {
                  border:1px solid $gray-300;
                  border-top-left-radius:$border-radius-lg;
                  border-bottom-left-radius:$border-radius-lg;
                  padding:10px 14px 10px 24px;
                  font-size: 12px;
                  flex:1;
                  line-height:120%;
                  color:$gray-600;
              }
              .bwi
              {
                  border-top-left-radius:0;
                  border-bottom-left-radius:0;
                  padding:10px 22px 10px 20px;
                  display:flex;
                  align-items: center;
                  white-space:nowrap;
              }
              &--content
              {
                  margin-top:20px;
                  width:100%;
                  max-width: $request-button-width;
                  display:flex;
              }
          }
          &--item
          {
              line-height: 100%;
              font-size: 20px;
              color:$dark-gray;
              padding:10px 16px 0 0;
              cursor: pointer;
              .active
              {
                  //font-size: 35px;
                  color:$cta;
                  font-weight: 600;
              }
              @include media-breakpoint-up(lg)
              {
                  font-size: 20px;
                  padding:20px 26px;
                  .active
                  {
                      font-size: 35px;
                  }
              }
          }
      }
      &--content
      {
      }
  }

  h2 {
    font-size: 25px;
    color: $black;
    text-align: center;
    font-weight: normal;
    margin-bottom: 0;

    strong {
      font-weight: 600;
    }
  }

  .services {
    margin-top: $grid-gutter-width;

    &__title {
      text-align: center;
      font-weight: 600;
      font-size: 25px;
      color: $black;
    }

    &__element {
      display: flex;
      align-items: center;
      margin-bottom: 30px;

      @include media-breakpoint-up(md) {
        margin-bottom: $grid-gutter-width;
      }
    }

    &__icon {
      background-color: $primary;
      border-radius: 100%;
      padding: 20px;
      width: 150px;
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__text {
      margin-bottom: 0;
      border: 1px solid $primary;
      font-size: 20px;
      font-weight: normal;
      border-radius: 20px;
      padding: 15px 20px 15px 70px;
      flex: auto;
      margin-left: -50px;
      z-index: -1;
    }
  }

  .vp {
    display: flex;
    justify-content: center;
    align-items: flex-start;

    &__text {
      font-size: 28px;
      margin-bottom: 0;
      border-radius: 30px;
      background-color: $primary;
      padding:$grid-gutter-width;
      color: $white;
      line-height: normal;
      display: none;

      @include media-breakpoint-up(lg) {
        display: block;
      }
    }

    &__image {
      width: 600px;
      border-radius: 10px;
      margin-top: $grid-gutter-width;
      position: relative;
      z-index: -1;

      @include media-breakpoint-up(lg) {
        margin-left: -$grid-gutter-width;
      }
    }
  }

  .fake_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 80px;

    p {
      border: 1px solid $primary;
      padding: 30px;
      font-size: 30px;
      color: $primary;
      border-radius: 15px;
      font-weight: 600;
    }
  }

  .prefooter {
    background-color: $tertiary;
    border-radius: 15px;
    color: $white;
    margin: 90px 20px 0;
    padding: 20px;

    @include media-breakpoint-up(lg) {
      padding: 40px 80px;
      margin: 90px 0;
    }

    &__element {
      display: flex;
      align-items: flex-start;

      &:nth-child(1), &:nth-child(2) {
        margin-bottom: 30px;

        @include media-breakpoint-up(md) {
          margin-bottom: 0;
        }
      }

      &:nth-child(3) {
        margin-bottom: 30px;

        @include media-breakpoint-up(md) {
          margin-bottom: 0;
        }
      }
    }

    &__text {
      margin-bottom: 0;
      margin-left: 10px;

      small {
        display: block;
      }
    }
  }
}
</style>